import { useState, useEffect } from "react";

export default function ClienteMod({cliente, onHandleCliente}){
    const [clienteInput, setClienteInput] = useState({
        nombre: cliente && cliente.nombre,
        cuitCuilDni: cliente && cliente.cuitCuilDni,
        ciudad: cliente && cliente.ciudad,
        direccion: cliente && cliente.direccion,
        cp: cliente && cliente.cp,
        zona: cliente && cliente.zona,
        telefono: cliente && cliente.telefono,
        notas: cliente && cliente.notas
    })
    //console.log(cliente);

    useEffect(() => {
        onHandleCliente(clienteInput)
    }, [clienteInput]);
    

    const handleChange = (e) => {
        const {value} = e.target
        setClienteInput({
            ...clienteInput,
            [e.target.name]: value
        })
    }

    return (
        <>
            <div className="h-[100px] text-[10pt] border-b">
            <div className="flex w-[1180px] mb-2 ">                
            <label className="block w-[70px] font-bold">Nombre</label>
            <input
                className="w-[500px] rounded border bg-slate-300 text-black font-semibold"
                type="text"
                name="nombre"
                value={clienteInput.nombre}
                onChange={handleChange}
            />            
            <label className="block w-[100px] ml-[100px] font-bold">Cuit/Cuil/DNI</label>
            <input
                className="rounded border bg-slate-300 text-black font-semibold"
                type="text"
                name="cuitCuilDni"
                value={clienteInput.cuitCuilDni}
                onChange={handleChange}
            />           
            </div>
            <div className="flex w-[1180px] mb-2">
            <label className="block w-[70px] font-bold">Ciudad</label>
            <input
                className="w-[250px] rounded border bg-slate-300 text-black font-semibold"
                type="text"
                name="ciudad"
                value={clienteInput.ciudad}
                onChange={handleChange}
            />
            <label className="block w-[70px] ml-[20px] font-bold">Direccion</label>
            <input
                className="w-[400px] rounded border bg-slate-300 text-black font-semibold"
                type="text"
                name="direccion"
                value={clienteInput.direccion}
                onChange={handleChange}
            />
            <label className="block w-[30px] ml-[20px] font-bold">CP</label>
            <input
                className="w-[80px] rounded border bg-slate-300 text-black font-semibold"
                type="text"
                name="cp"
                value={clienteInput.cp}
                onChange={handleChange}
            />
            <label className="block w-[40px] ml-[20px] font-bold">Zona</label>
            <select
                className="w-[100px] rounded border bg-slate-300 text-black font-semibold text-center"
                type="text"
                name="zona"
                value={clienteInput.zona}
                onChange={handleChange}                
            >
                <option value="">Elegir Zona</option>
                <option value="CABA">CABA</option>
                <option value="Norte">Norte</option>
                <option value="Oeste">Oeste</option>
                <option value="Sur">Sur</option>
            </select>
            </div>
            <div className="flex">
            <label className="block w-[70px] font-bold">Telefono</label>
            <input
                className="w-[250px] rounded border bg-slate-300 text-black font-semibold"
                type="text"
                name="telefono"
                value={clienteInput.telefono}
                onChange={handleChange}
            />
            <label className="w-[50px] ml-[20px] font-bold">Notas</label>
            <input
                className="w-[600px] rounded border bg-slate-300 text-black font-semibold"
                type="text"
                name="notas"
                value={clienteInput.notas}
                onChange={handleChange}
            />
            </div>
            </div>
        </>
    )
}